import { useNumberLocale } from '../../utils/numberFormat';

export function useChartFormatters() {
    const locale = useNumberLocale();

    const formatYAxisTick = (value: any) => {
        const num = typeof value === 'number' ? value : parseFloat(value);
        if (!isFinite(num)) return '';
        const abs = Math.abs(num);
        if (abs >= 1e9) return (num / 1e9).toLocaleString(locale, { maximumFractionDigits: 1 }) + 'B';
        if (abs >= 1e6) return (num / 1e6).toLocaleString(locale, { maximumFractionDigits: 1 }) + 'M';
        if (abs >= 1e3) return (num / 1e3).toLocaleString(locale, { maximumFractionDigits: 1 }) + 'k';
        return num.toLocaleString(locale, { maximumFractionDigits: 0 });
    };

    const formatTooltipValue = (value: any) => {
        const num = typeof value === 'number' ? value : parseFloat(value);
        if (!isFinite(num)) return value;
        return num.toLocaleString(locale, { maximumFractionDigits: 0 });
    };

    return { formatYAxisTick, formatTooltipValue };
}

// Returns the last data-point date of each year present in the input.
// Used to build year-end ticks for the X axis. Returns undefined when fewer
// than 2 distinct years are present (recharts then picks its own ticks).
export function getYearEndTicks(dates: string[]): string[] | undefined {
    const lastByYear = new Map<string, string>();
    for (const d of dates) {
        if (!d || d.length < 4) continue;
        const year = d.substring(0, 4);
        const existing = lastByYear.get(year);
        if (!existing || d > existing) {
            lastByYear.set(year, d);
        }
    }
    if (lastByYear.size < 2) return undefined;
    return Array.from(lastByYear.values()).sort();
}

export const formatYearTickLabel = (value: any) => {
    if (typeof value !== 'string' || value.length < 4) return value;
    return value.substring(0, 4);
};
